import actions from './actions';
import mutations, { INIT_STATE } from './mutations';

export default {
  namespaced: true,
  state: { ...INIT_STATE },
  actions,
  mutations
};
